(function ($) {
    
    function eventSlider() {
        $('.js-event-vertical').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            vertical: true,
            verticalSwiping: true,
            arrows: true,
            dots: false,
            adaptiveHeight: false
        });
        
        var maxHeight = -1;
        $('.js-event-vertical .slick-slide').each(function() {
          if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
          }
          if ($(this).height() < maxHeight) {
            $(this).css('margin', Math.ceil((maxHeight-$(this).height())/2) + 'px 0');
          }
        });
        
    }
    
    /* Document Ready */
	$(document).ready(function() {

        eventSlider();
        
	});
    
    $(window).on('resize orientationchange', function() {
        $('.js-event-vertical').slick('resize');
        
        var maxHeight = -1;
        $('.js-event-vertical .slick-slide').each(function() {
          if ($(this).height() > maxHeight) {
            maxHeight = $(this).height();
          }
          if ($(this).height() < maxHeight) {
            $(this).css('margin', Math.ceil((maxHeight-$(this).height())/2) + 'px 0');
          }
        });
    });

})(jQuery);